"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchMedicareEnrollmentProspectService = void 0;
const utils_1 = require("@hc-frontend/utils");
const config_1 = require("../config");
/**
 * Function to get url to redirect users to shop.healthcare.com.
 *
 * API repository
 * @see https://github.com/healthcarecom/pivot-health-medicare-enrollment-api/
 *
 * Sunfire Documentation
 * @see https://www.sunfirematrix.com/documentation/#incoming-prospect-post-api
 *
 * @public
 *
 * @param {IFetchMedicareEnrollmentProspectPayload} payload - Payload required for endpoint;
 *
 * @returns {IFetchMedicareEnrollmentProspectResponse | null} Object with prospect urls
 *
 *
 * @example
 *
 * ```ts
 * const payload = { ... }
 * const response = await fetchRedirectToShopHCService(payload);
 * ```
 */
async function fetchMedicareEnrollmentProspectService(payload) {
    const { parsedBody } = await (0, utils_1.fetchJSON)(`${(0, config_1.getHealthcareApiURI)()}/medicare-enrollment/prospect/`, {
        body: payload,
    });
    return (parsedBody === null || parsedBody === void 0 ? void 0 : parsedBody.id) ? parsedBody : null;
}
exports.fetchMedicareEnrollmentProspectService = fetchMedicareEnrollmentProspectService;
//# sourceMappingURL=fetch-medicare-enrollment-prospect-service.js.map